import { MutableRefObject, useLayoutEffect, useState } from 'react';
import { BREAKPOINTS } from '../constants/breakpoints.constant';

interface ContainerBreakpoints {
  width: number;
  isSmallScreen: boolean;
  isLargeScreen: boolean;
  isExtraScreen: boolean;
}

const useContainerWidth = (
  ref: MutableRefObject<HTMLElement | null>,
): ContainerBreakpoints => {
  const [width, setWidth] = useState(0);

  useLayoutEffect(() => {
    const observer = new ResizeObserver((entries) => {
      for (const entry of entries) {
        setWidth(entry.contentRect.width);
      }
    });
    if (ref.current) {
      observer.observe(ref.current);
    }
    return () => observer.disconnect();
  }, [ref]);

  return {
    width,
    isSmallScreen: width > 0 && width < BREAKPOINTS.SM,
    isLargeScreen: width >= BREAKPOINTS.SM && width < BREAKPOINTS.LG,
    isExtraScreen: width >= BREAKPOINTS.LG && width < BREAKPOINTS.XL,
  };
};

export default useContainerWidth;
